import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import { useEffect, useState, useCallback } from "react";
import TitleCustom from "components/CustomTitle";
import DownloadIcon from "@mui/icons-material/Download";
import MDButton from "components/MDButton";
import Tooltip from "@mui/material/Tooltip";
import DataTable from "examples/Tables/DataTable";
import getTableData from "./getTableData";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { getExcelData } from "./getExcelData";
import EditProduct from "./editProduct";
import DropzoneDialogExample from "./dropZone";
import { productsByCompany } from "rest/requests";
import { companiesSync } from "rest/sync/requestsSync";
import CommonSelect from "components/CommonSelect/select";
import AddIcon from "@mui/icons-material/Add";
import { downloadTemplateAddProduct } from "rest/sync/requestsSync";

const toolTipText =
  "Se descargara un archivo excel con un formato definido para cargar masivamente productos.";

function buildTitle(companiesCatalog, selectedCompany) {
  try {
    var company = companiesCatalog.filter((elem) => {
      return elem.id === selectedCompany;
    })[0].name;
    return "Administracion_Productos_" + company + ".xlsx";
  } catch {
    return "Administracion_Productos.xlsx";
  }
}

function Products() {
  const companiesCatalog = companiesSync();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showLoadFile, setShowLoadFile] = useState(false);
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(false);
  const [elementToEdit, setElementToEdit] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const getData = useCallback(async () => {
    if (selectedCompany) {
      setProducts(await productsByCompany(selectedCompany));
    }
  }, [selectedCompany, editing, deleting]);

  useEffect(() => {
    getData();
  }, [selectedCompany]);

  useEffect(() => {
    getData();
  }, [deleting, editing]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Administración de Productos"}
        excelData={getExcelData(products)}
        excelName={buildTitle(companiesCatalog, selectedCompany)}
      ></TitleCustom>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container spacing={3}>
          <Grid item>
            <CommonSelect
              data={companiesCatalog}
              onChange={(selectedValue) => setSelectedCompany(selectedValue)}
              label={selectedCompany ? "Empresa" : "Seleccione Empresa"}
            ></CommonSelect>
          </Grid>
        </Grid>
        <Tooltip title={toolTipText}>
          <MDButton
            disabled={selectedCompany === null}
            variant="text"
            color="success"
            onClick={() => downloadTemplateAddProduct()}
          >
            <DownloadIcon></DownloadIcon>
            Plantilla Productos
          </MDButton>
        </Tooltip>
        <Tooltip title={"Subir plantilla con los productos previamente adicionados"}>
          <MDButton
            disabled={selectedCompany === null}
            variant="text"
            color="dark"
            onClick={() => setShowLoadFile(true)}
          >
            <FileUploadIcon></FileUploadIcon>
            Cargar productos
          </MDButton>
        </Tooltip>

        <MDButton
          variant="text"
          size="small"
          color="secondary"
          disabled={!selectedCompany || editing}
          onClick={() => {
            setElementToEdit(null);
            setEditing(true);
          }}
        >
          <AddIcon></AddIcon>
          Adicionar Producto
        </MDButton>

        {showLoadFile ? (
          <DropzoneDialogExample
            open={showLoadFile}
            setOpen={setShowLoadFile}
          ></DropzoneDialogExample>
        ) : (
          <div></div>
        )}
      </MDBox>
      <br></br>
      {editing ? (
        <EditProduct
          productToEdit={elementToEdit}
          setEditing={setEditing}
          selectedCompany={selectedCompany}
        ></EditProduct>
      ) : (
        <>
          <DataTable
            table={getTableData(products, setEditing, setElementToEdit, setDeleting)}
            canSearch={true}
          />
        </>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Products;
